module.exports = __webpack_public_path__ + "img/melilla.c0f45032.svg";